<template>
  <div>
    <form data-vv-scope="Course">
      <div class="border_btm py-2">
        <h4>Course Description</h4>
        <vs-row class="my-6">
          <vs-col vs-lg="5" vs-sm="12">
            <div class="image_preview_holder">
              <div
                class="flex flex-col justify-center items-center w-full h-full"
                v-if="!preview"
              >
                <svg
                  width="62"
                  height="62"
                  viewBox="0 0 62 62"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M49.9229 19.7628V14.2086H44.3687V10.3336H49.9229V4.71484H53.7979V10.3336H59.4167V14.2086H53.7979V19.7628H49.9229ZM6.07083 56.8336C5.0375 56.8336 4.13333 56.4461 3.35833 55.6711C2.58333 54.8961 2.19583 53.9919 2.19583 52.9586V19.8273C2.19583 18.8371 2.58333 17.9437 3.35833 17.1471C4.13333 16.3506 5.0375 15.9523 6.07083 15.9523H15.5646L20.2792 10.3336H38.3625V14.2086H22.0875L17.3729 19.8273H6.07083V52.9586H49.9875V25.8336H53.8625V52.9586C53.8625 53.9919 53.4642 54.8961 52.6677 55.6711C51.8712 56.4461 50.9778 56.8336 49.9875 56.8336H6.07083ZM28.0292 47.4044C31.1292 47.4044 33.734 46.3496 35.8437 44.2398C37.9535 42.1301 39.0083 39.5037 39.0083 36.3607C39.0083 33.2607 37.9535 30.6666 35.8437 28.5784C33.734 26.4902 31.1292 25.4461 28.0292 25.4461C24.8861 25.4461 22.2705 26.4902 20.1823 28.5784C18.0941 30.6666 17.05 33.2607 17.05 36.3607C17.05 39.5037 18.0941 42.1301 20.1823 44.2398C22.2705 46.3496 24.8861 47.4044 28.0292 47.4044ZM28.0292 43.5294C25.9625 43.5294 24.2618 42.8513 22.9271 41.4951C21.5924 40.1388 20.925 38.4273 20.925 36.3607C20.925 34.3371 21.5924 32.6579 22.9271 31.3232C24.2618 29.9885 25.9625 29.3211 28.0292 29.3211C30.0528 29.3211 31.7427 29.9885 33.099 31.3232C34.4552 32.6579 35.1333 34.3371 35.1333 36.3607C35.1333 38.4273 34.4552 40.1388 33.099 41.4951C31.7427 42.8513 30.0528 43.5294 28.0292 43.5294Z"
                    fill="#808080"
                  />
                </svg>
                <h4 style="color: #808080" class="my-2">Add course image</h4>
              </div>
              <input
                type="file"
                accept="image/*"
                @change="previewImage($event)"
              />
              <template v-if="preview">
                <img :src="preview" class="image" />
              </template>
            </div>

            <div class="py-4">
              <div class="pb-3" v-if="preview_video">
                {{ video.name }}
              </div>
              <div class="button_file_holder">
                <input
                  type="file"
                  accept="video/mp4,video/x-m4v,video/*"
                  @change="previewVideo"
                />
                <vs-button icon="upload">Upload Course Preview Video</vs-button>
              </div>
            </div>
          </vs-col>
          <vs-col vs-lg="7" vs-sm="12" class="sm:pl-4 pl-0">
            <vs-row>
              <vs-col vs-w="12" class="p-2">
                <label class="vs-input--label required">Course title</label>
                <vs-input
                  v-model="coursePayload.name"
                  placeholder="Enter course title"
                  class="w-full"
                  v-validate="'required'"
                  data-vv-name="course title"
                />
                <span
                  v-show="errors.has('Course.course title')"
                  class="text-danger block"
                  >{{ errors.first("Course.course title") }}</span
                >
              </vs-col>
              <vs-col vs-w="12" class="p-2">
                <label class="vs-input--label">Subject(s)</label>
                <div
                  class="full_cstm_select_opt_holder"
                  v-click-outside="outsideDropdown"
                >
                  <div class="selected_opt_holder" @click="showDropdown">
                    <span
                      class="placeholderSpan"
                      v-if="
                        subjects.length == 0 && !disableOtherLi && !searchOption
                      "
                      >Subject Name</span
                    >
                    <span class="selectedSpan" v-else-if="disableOtherLi">
                      General Subject
                      <feather-icon icon="XIcon" @click.stop="removeGenSub" />
                    </span>
                    <span
                      class="selectedSpan"
                      v-else
                      v-for="(eachData, index) in subjects"
                      :key="index"
                    >
                      {{ eachData.subject_name }}
                      <feather-icon
                        icon="XIcon"
                        @click.stop="removeDataOption(index, eachData.id)"
                      />
                    </span>
                    <!-- search input -->
                    <input
                      type="search"
                      v-model="searchOption"
                      @keyup="searchSubjectList"
                    />
                    <feather-icon
                      icon="ChevronDownIcon"
                      class="downarrow mr-2"
                      :class="[show ? 'rotate' : '']"
                    />
                  </div>
                  <div class="dropdown_holder" :class="[show ? 'show' : '']">
                    <ul>
                      <li>
                      <span
                        @click.prevent="addSubjectPopup = !addSubjectPopup"
                        style="color: rgba(var(--vs-primary), 1)"
                        >Add New Subject</span
                      >
                    </li>
                      <li>
                        <span @click="genSub">General Subject</span>
                      </li>
                      <li
                        v-for="(option, opt) in subjectlist"
                        :key="opt"
                        :class="[disableOtherLi ? 'disabled' : '']"
                      >
                        <span
                          @click="pushTolocalValue(option)"
                          :class="[option.selected ? 'disabled' : '']"
                          >{{ option.subject_name }}</span
                        >
                      </li>
                      <li
                        ref="load"
                        class="loader"
                        v-show="subjectMeta.has_next"
                      >
                        Loading more subjects...
                      </li>
                    </ul>
                  </div>
                </div>
              </vs-col>
              <vs-col vs-w="12" class="p-2">
                <label class="vs-input--label">Course Description</label>
                <vs-textarea
                  v-model="coursePayload.description"
                  class="mb-0"
                ></vs-textarea>
              </vs-col>
              <vs-col vs-lg="6" vs-sm="12" class="p-2">
                <label class="vs-input--label">Course Pricing</label>
                <v-select
                  :disabled="coursePayload.is_purchased"
                  placeholder="Select pricing"
                  class="w-full"
                  label="name"
                  :reduce="(option) => option.id"
                  :options="coursePricings"
                  v-model="coursePaymentSetting.course_payment_type"
                ></v-select>
              </vs-col>
              <vs-col
                vs-lg="3"
                vs-sm="6"
                class="p-2"
                v-if="coursePaymentSetting.course_payment_type == 5"
              >
                <label class="vs-input--label">Subscription Price</label>
                <div class="cstm_icon_input_holder">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="12"
                    viewBox="0 0 11 12"
                    fill="none"
                  >
                    <path
                      d="M4.24 10.256H10.016V12H0.48V10.256H2.16V7.056H0.48V5.744H2.16V5.008C2.16 4.12267 2.352 3.35467 2.736 2.704C3.13067 2.04267 3.70133 1.536 4.448 1.184C5.19467 0.821333 6.09067 0.639999 7.136 0.639999C8.40533 0.639999 9.456 0.890666 10.288 1.392L9.632 3.088C8.98133 2.672 8.112 2.464 7.024 2.464C6.11733 2.464 5.424 2.68267 4.944 3.12C4.47467 3.54667 4.24 4.17067 4.24 4.992V5.744H8.288V7.056H4.24V10.256Z"
                      fill="#5E5873"
                    />
                  </svg>
                  <input
                    type="text"
                    class="w-full"
                    :disabled="coursePayload.is_purchased"
                    v-model="coursePaymentSetting.total_price"
                  />
                </div>
              </vs-col>
              <vs-col
                vs-lg="3"
                vs-sm="6"
                class="p-2"
                v-if="coursePaymentSetting.course_payment_type == 5"
              >
                <label class="vs-input--label">Subscription Frequency</label>
                <v-select
                  v-model="coursePaymentSetting.payment_term_type"
                  placeholder="Subscription frequency"
                  label="name"
                  :reduce="(option) => option.id"
                  :options="frequencyArray"
                  class="w-full"
                ></v-select
              ></vs-col>
              <vs-col
                vs-lg="6"
                vs-sm="12"
                class="p-2"
                v-if="
                  coursePaymentSetting.course_payment_type != 1 &&
                  coursePaymentSetting.course_payment_type != 3 &&
                  coursePaymentSetting.course_payment_type != 5
                "
              >
                <label class="vs-input--label">Total Price</label>
                <div class="cstm_icon_input_holder">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="12"
                    viewBox="0 0 11 12"
                    fill="none"
                  >
                    <path
                      d="M4.24 10.256H10.016V12H0.48V10.256H2.16V7.056H0.48V5.744H2.16V5.008C2.16 4.12267 2.352 3.35467 2.736 2.704C3.13067 2.04267 3.70133 1.536 4.448 1.184C5.19467 0.821333 6.09067 0.639999 7.136 0.639999C8.40533 0.639999 9.456 0.890666 10.288 1.392L9.632 3.088C8.98133 2.672 8.112 2.464 7.024 2.464C6.11733 2.464 5.424 2.68267 4.944 3.12C4.47467 3.54667 4.24 4.17067 4.24 4.992V5.744H8.288V7.056H4.24V10.256Z"
                      fill="#5E5873"
                    />
                  </svg>
                  <input
                    class="w-full"
                    onkeypress="return (event.charCode >= 48)"
                    min="0"
                    @keyup="calculateInstallmentAmt"
                    :disabled="coursePayload.is_purchased"
                    type="number"
                    v-model="coursePaymentSetting.total_price"
                  />
                </div>
              </vs-col>
              <vs-col
                vs-lg="6"
                vs-sm="12"
                class="p-2"
                v-if="coursePaymentSetting.course_payment_type == 3"
              >
                <label class="vs-input--label">Price Per Session</label>
                <div class="cstm_icon_input_holder">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="12"
                    viewBox="0 0 11 12"
                    fill="none"
                  >
                    <path
                      d="M4.24 10.256H10.016V12H0.48V10.256H2.16V7.056H0.48V5.744H2.16V5.008C2.16 4.12267 2.352 3.35467 2.736 2.704C3.13067 2.04267 3.70133 1.536 4.448 1.184C5.19467 0.821333 6.09067 0.639999 7.136 0.639999C8.40533 0.639999 9.456 0.890666 10.288 1.392L9.632 3.088C8.98133 2.672 8.112 2.464 7.024 2.464C6.11733 2.464 5.424 2.68267 4.944 3.12C4.47467 3.54667 4.24 4.17067 4.24 4.992V5.744H8.288V7.056H4.24V10.256Z"
                      fill="#5E5873"
                    />
                  </svg>
                  <input
                    class="w-full"
                    type="text"
                    v-model="coursePaymentSetting.price_per_session"
                  />
                </div>
              </vs-col>
              <vs-row
                v-if="coursePaymentSetting.course_payment_type == 4"
                class="grey_holder p-4 m-2"
              >
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                  <label class="vs-input--label block"
                    >Payment cycle in every</label
                  >
                  <vs-col vs-lg="6" vs-sm="12" class="p-2">
                    <vs-input
                      onkeypress="return (event.charCode >= 48)"
                      min="0"
                      type="number"
                      v-model="coursePaymentSetting.payment_term_no"
                      placeholder="Payment term no"
                      class="w-full"
                    />
                  </vs-col>
                  <vs-col vs-lg="6" vs-sm="12" class="p-2">
                    <v-select
                      v-model="coursePaymentSetting.payment_term_type"
                      placeholder="Payment term type"
                      label="name"
                      :reduce="(option) => option.id"
                      :options="payment_term_type_options"
                      class="w-full"
                    ></v-select>
                  </vs-col>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                  <vs-row>
                    <vs-col vs-lg="6" vs-sm="12" class="p-2">
                      <label class="vs-input--label block"
                        >No. of payment</label
                      >
                      <vs-input
                        onkeypress="return (event.charCode >= 48)"
                        min="0"
                        type="number"
                        @input="calculateInstallmentAmt"
                        v-model="coursePaymentSetting.no_of_installments"
                        placeholder="Enter pricing"
                        class="w-full"
                      />
                    </vs-col>
                    <vs-col vs-lg="6" vs-sm="12" class="p-2">
                      <label class="vs-input--label block"
                        >Installment Amount</label
                      >
                      <vs-input
                        class="w-full"
                        disabled
                        v-model="coursePaymentSetting.installment_amount"
                        type="number"
                      />
                    </vs-col>
                  </vs-row>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="px-4 py-2">
                  <label class="vs-input--label block"
                    >First payment date</label
                  >
                  <v-select
                    v-model="coursePaymentSetting.first_payment_type_id"
                    label="name"
                    :reduce="(option) => option.id"
                    :options="payment_date_option"
                    placeholder="Select"
                    class="w-full"
                  ></v-select>
                </vs-col>
              </vs-row>
              <!-- <vs-row
              v-if="coursePaymentSetting.course_payment_type == 5"
              class="grey_holder p-4 m-2"
            >
              <vs-row>
                 <vs-col vs-lg="6" vs-sm="12" class="p-2">
                <label class="vs-input--label block"
                  >Payment cycle in every</label
                >
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                  <vs-input
                    type="number"
                    v-model="coursePaymentSetting.payment_term_no"
                    placeholder="Payment term no"
                    class="w-full"
                  />
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                  <v-select
                    v-model="coursePaymentSetting.payment_term_type"
                    placeholder="Payment term type"
                    label="name"
                    :reduce="option => option.id"
                    :options="payment_term_type_options"
                    class="w-full"
                  ></v-select>
                </vs-col>
              </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                  <label class="vs-input--label block">No. of payment</label>
                  <v-select
                    @input="calculateInstallmentAmt"
                    v-model="coursePaymentSetting.no_of_installments"
                    placeholder="Select pricing"
                    :options="no_of_installments_options"
                    class="w-full"
                  ></v-select>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                  <label class="vs-input--label block"
                      >Installment Amount</label
                    >
                    <vs-input
                      disabled
                      v-model="coursePaymentSetting.installment_amount"
                      type="number"
                    />
                </vs-col>
              </vs-row>
            </vs-row> -->
            </vs-row>
          </vs-col>
        </vs-row>
      </div>

      <!-- course tutor -->
      <div class="border_btm py-6">
        <h4 class="mb-4">Course Tutor(s)</h4>
        <vs-row>
          <vs-col vs-w="12">
            <label class="vs-input--label">Select Teacher(s)</label>
            <v-select
              multiple
              v-model="tutors"
              :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
              class="w-full"
              placeholder="Select Teacher"
              :clearable="false"
              @open="onOpenTeacher"
              @close="onCloseTeacher"
              :options="teacherList"
              @search="fuseSearch"
            >
              <template v-slot:selected-option="teacherList">
                <img
                  v-if="teacherList.picture"
                  class="person-img rounded-full"
                  :src="teacherList.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />
                {{ teacherList.first_name }}
                {{ teacherList.last_name }}
              </template>
              <template v-slot:option="teacherList">
                <img
                  v-if="teacherList.picture"
                  class="person-img rounded-full"
                  :src="teacherList.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />
                {{ teacherList.first_name }}
                {{ teacherList.last_name }}
              </template>
              <template #list-footer>
                <li
                  ref="loadTeacher"
                  class="loader"
                  v-show="teacher_meta.has_next"
                >
                  Loading more teacher...
                </li>
              </template>
            </v-select>
          </vs-col>
          <!-- <vs-col vs-lg="6" vs-sm="12" class="sm:pl-4 pl-0">
          <label class="vs-input--label block p-0">Selected Teacher(s)</label>
          <div class="each_member">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="16" cy="16" r="16" fill="#3AC2D4" />
              <path
                d="M12 11.1113C12 13.3167 13.7947 15.1113 16 15.1113C18.2053 15.1113 20 13.3167 20 11.1113C20 8.90599 18.2053 7.11133 16 7.11133C13.7947 7.11133 12 8.90599 12 11.1113ZM23.1111 24.0002H24V23.1113C24 19.6811 21.208 16.8891 17.7778 16.8891H14.2222C10.7911 16.8891 8 19.6811 8 23.1113V24.0002H23.1111Z"
                fill="white"
              />
            </svg>
            <span class="name">John Doe</span>
            <span class="material-icons-outlined cancel">cancel</span>
          </div>
          <div class="each_member">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="16" cy="16" r="16" fill="#3AC2D4" />
              <path
                d="M12 11.1113C12 13.3167 13.7947 15.1113 16 15.1113C18.2053 15.1113 20 13.3167 20 11.1113C20 8.90599 18.2053 7.11133 16 7.11133C13.7947 7.11133 12 8.90599 12 11.1113ZM23.1111 24.0002H24V23.1113C24 19.6811 21.208 16.8891 17.7778 16.8891H14.2222C10.7911 16.8891 8 19.6811 8 23.1113V24.0002H23.1111Z"
                fill="white"
              />
            </svg>
            <span class="name">William Smith</span>
            <span class="material-icons-outlined cancel">cancel</span>
          </div>
          <div class="inline-flex items-center">
            <span class="material-icons-outlined">add_circle_outline</span>
            <span class="pl-1">More</span>
          </div>
        </vs-col> -->
        </vs-row>
      </div>

      <!-- course structure -->
      <div class="border_btm py-6">
        <h4 class="mb-4">Course Structure</h4>
        <vs-row>
          <vs-col vs-lg="6" vs-sm="12" class="sm:pr-4 pr-0">
            <vs-row>
              <vs-col vs-w="12" class="p-2">
                <label class="vs-input--label">Course type</label>
                <v-select
                  :disabled="coursePayload.is_purchased"
                  label="value"
                  :options="course_types"
                  v-model="courseStructure.course_type"
                  placeholder="Select..."
                  class="w-full"
                  :clearable="true"
                ></v-select>
              </vs-col>
              <div v-if="courseStructure.course_type">
                <vs-col
                  vs-w="12"
                  class="p-2"
                  v-if="
                    courseStructure.course_type.type == 'offline_one_2_many' ||
                    courseStructure.course_type.type == 'online_one_2_many'
                  "
                >
                  <label class="vs-input--label">Max Capacity</label>
                  <vs-input
                    placeholder="Max Capacity"
                    type="number"
                    v-model="courseStructure.max_capacity"
                    style="width: 200px"
                  />
                </vs-col>
              </div>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="6" vs-sm="12" class="sm:pl-4 pl-0">
            <vs-row>
              <vs-col vs-w="12" class="p-2">
                <label class="vs-input--label">Delivery location</label>
                <v-select
                  :reduce="(options) => options.id"
                  label="name"
                  :options="locations"
                  v-model="courseStructure.delivery_location_id"
                  placeholder="Select..."
                  class="w-full"
                ></v-select>
              </vs-col>
              <vs-row v-if="courseStructure.delivery_location_id == 4">
                <vs-col vs-w="12" class="p-2">
                  <label class="vs-input--label">Address</label>
                  <vs-textarea
                    Placeholder="Other Location"
                    v-model="courseStructure.other_delivery_location"
                  />
                </vs-col>
              </vs-row>

              <vs-row v-if="courseStructure.delivery_location_id == 1">
                <vs-col vs-w="12" class="flex flex-wrap items-center p-2">
                  <div
                    class="flex flex-wrap justify-between items-center w-full"
                  >
                    <div class="inline-flex">
                      <span style="width: 200px">Preferred Classrooms</span>
                      <vs-switch
                        v-model="courseStructure.is_preferred_classroom"
                      />
                    </div>
                    <vs-checkbox
                      v-if="courseStructure.is_preferred_classroom"
                      v-model="courseStructure.flexible_class_room_requirement"
                      >Flexible requirement</vs-checkbox
                    >
                  </div>
                </vs-col>
                <vs-col vs-w="12" class="flex flex-wrap items-center p-2">
                  <v-select
                    multiple
                    v-if="courseStructure.is_preferred_classroom"
                    :reduce="(options) => options.assets_id"
                    label="name"
                    :options="roomList"
                    placeholder="Choose Room"
                    class="w-full"
                    @open="onOpenRoom"
                    @close="onCloseRoom"
                    v-model="room_ids"
                  >
                    <template #list-footer>
                      <li
                        ref="loadRooms"
                        class="loader"
                        v-show="room_meta.has_next"
                      >
                        Loading more rooms...
                      </li>
                    </template>
                  </v-select>
                </vs-col>
                <vs-col vs-w="12" class="flex flex-wrap items-center p-2">
                  <div
                    class="flex flex-wrap justify-between items-center w-full"
                  >
                    <div class="inline-flex">
                      <span style="width: 200px">Special Equipment</span>
                      <vs-switch
                        v-model="courseStructure.is_required_special_equipments"
                      />
                    </div>
                    <vs-checkbox
                      disabled
                      v-if="courseStructure.is_required_special_equipments"
                      v-model="courseStructure.flexible_asset_requirement"
                      >Flexible requirement</vs-checkbox
                    >
                  </div>
                </vs-col>
                <vs-col vs-w="12" class="flex flex-wrap items-center p-2">
                  <v-select
                    multiple
                    v-if="courseStructure.is_required_special_equipments"
                    placeholder="Select equipment"
                    :reduce="(options) => options.assets_id"
                    label="name"
                    :options="inventoryList"
                    class="w-full"
                    @open="onOpenInventory"
                    @close="onCloseInventory"
                    v-model="courseAsset"
                  >
                    <template #list-footer>
                      <li
                        ref="loadInventory"
                        class="loader"
                        v-show="inventory_meta.has_next"
                      >
                        Loading more equipment...
                      </li>
                    </template>
                  </v-select>
                </vs-col>
              </vs-row>
              <vs-row v-if="courseStructure.delivery_location_id == 2">
                <vs-col vs-w="12" class="flex flex-wrap items-center p-2">
                  <div
                    class="flex flex-wrap justify-between items-center w-full"
                  >
                    <label class="vs-input--label">Media</label>
                    <v-select
                      :reduce="(options) => options.id"
                      label="name"
                      :options="onlineOptions"
                      v-model="courseStructure.online_media_id"
                      placeholder="Select..."
                      class="w-full"
                    >
                      <template #selected-option="{ name, icon }">
                        <div class="flex items-center">
                          <img :src="icon" alt="icon" />
                          <p class="ml-1">{{ name }}</p>
                        </div>
                      </template>
                      <template #option="{ name, icon }">
                        <div class="flex items-center">
                          <img :src="icon" alt="icon" />
                          <p class="ml-1">{{ name }}</p>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </vs-col>
              </vs-row>
              <vs-row
                v-if="
                  courseStructure.delivery_location_id == 2 &&
                  courseStructure.online_media_id == 4
                "
              >
                <vs-col vs-w="12" class="flex flex-wrap items-center p-2">
                  <div
                    class="flex flex-wrap justify-between items-center w-full"
                  >
                    <label class="vs-input--label">Software Name</label>
                    <vs-input
                      Placeholder="Software Name"
                      v-model="courseStructure.other_online_media"
                      class="w-full"
                    />
                  </div>
                </vs-col>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
      <div class="flex flex-wrap justify-center items-center mt-4">
        <vs-button v-if="this.$route.params.course_id" @click="updateCourse()"
          >Save & Next</vs-button
        >
        <vs-button v-else @click="createCourse()">Save & Next</vs-button>
      </div>
    </form>
    <vs-popup title="Add Subject" :active.sync="addSubjectPopup">
      <form data-vv-scope="addSub">
        <label class="text-sm">Subject Name</label>
        <vs-input
          class="inputx mb-2 w-full"
          v-validate="'required'"
          name="subname"
          v-model="subject_name"
          @keypress="preventKeypress"
        />
        <span v-show="errors.has('addSub.subname')" class="text-danger block">{{
          errors.first("addSub.subname")
        }}</span>
        <label class="text-sm">Subject Description</label>
        <vs-textarea
          class="mb-2 w-full"
          name="subdesc"
          v-model="subject_description"
        />
        <vs-col
          :vs-xs="12"
          :vs-md="12"
          :vs-lg="12"
          class="p-2 centerx"
          vs-type="flex"
          vs-justify="space-between"
        >
        </vs-col>
        <FileUpload
          section_type="courseHeader"
          :multiplefile="false"
          @getFileIdHeader="getIdFile"
          :file_repository_id="repository_id"
          :filesInfo="filesInfo"
          @deletedIndex="deletedIndex"
          ref="fileUploadRef"
        >
        </FileUpload>
        <vs-divider />
        <vs-button @click="add_subject" class="mt-2" type="filled"
          >Create Subject</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import FileUpload from '@/components/common/FileUpload'
import vSelect from 'vue-select'
import { list_subject } from '@/api/subject'

import {
  createCourseDetails,
  getCourseDetails,
  updateCourseDetails
} from '@/api/courseBuilder.js'
import { UploadImage } from '@/api/common'
import { addFile } from '@/api/file'
import { repository } from '@/mixins/repository'
import { inventoryOrRoomListApi } from '@/api/room'

import { CourseBuilder } from '../mixin/courseBuilderMixin'
import { Subject } from '@/mixins/subject/subject'
import { handleKeypress } from '@/mixins/handleKeypress'


export default {
  mixins: [CourseBuilder, repository, Subject, handleKeypress],
  data () {
    return {
      tutors: [],
      onlineOptions: [
        {
          id: 1,
          name: 'Zoom',
          icon: 'https://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/zoom.svg'
        },
        {
          id: 2,
          name: 'Skype',
          icon: 'https://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/skype.svg'
        },
        {
          id: 3,
          name: 'Teams',
          icon: 'https://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/teams.svg'
        },
        {
          id: 4,
          name: 'Others',
          icon: 'https://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/others.svg'
        }
      ],
      room_ids: [],
      observerSubject: new IntersectionObserver(this.loadMore),
      observerInventory: new IntersectionObserver(this.loadMoreInventory),
      courseStructure: {
        course_type: {
          id: 4,
          type: 'offline_one_2_one',
          value: 'In Person Individual Course'
        },

        course_class_type: '',
        max_capacity: '',
        delivery_location_id: 1,
        other_delivery_location: '',
        flexible_class_room_requirement: true,
        is_preferred_classroom: '',
        is_required_special_equipments: '',
        flexible_asset_requirement: true,
        online_media_id: '',
        other_online_media: '',
        courseClassPrioritySetting: []
      },
      courseAsset: [],
      payment_date_option: [
        {
          id: 1,
          name: 'On Booking'
        },
        {
          id: 2,
          name: 'As Scheduled'
        }
      ],
      coursePaymentSetting: {
        course_payment_type: 1,
        total_price: 0,
        price_per_session: 0,
        payment_term_type: '',
        payment_term_no: '',
        no_of_installments: '',
        installment_amount: '',
        first_payment_type_id: ''
      },
      coursePayload: {
        name: '',
        platform_module_id: 3,
        description: '',
        custom: 0,
        is_purchased: false
      },
      has_all_subject: true,
      show: false,
      searchOption: '',
      disableOtherLi: true,
      observer: new IntersectionObserver(this.loadMore),
      selectAllSubjects: false,
      allSub: true,
      subjectMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },

      inventory_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      selectedSubject: [],
      subjectlist: [],
      subjects: [],
      preview: null,
      image: null,
      preview_video: false,
      video: null,
      coursePricings: [
        {
          id: 1,
          name: 'Free'
        },
        {
          id: 2,
          name: 'Buy Now'
        },
        {
          id: 3,
          name: 'Per Session'
        },
        {
          id: 4,
          name: 'Recurring Payment'
        },
        {
          id: 5,
          name: 'Subscription'
        }
      ],
      frequencyArray: [
        {
          id: 1,
          name: 'daily'
        },
        {
          id: 2,
          name: 'weekly'
        },
        {
          id: 3,
          name: 'monthly'
        },
        {
          id: 4,
          name: 'yearly'
        }
      ],
      payment_term_type_options: [
        {
          id: 1,
          name: 'Days'
        },
        {
          id: 2,
          name: 'Week'
        },
        {
          id: 3,
          name: 'Months'
        },
        {
          id: 4,
          name: 'Year'
        }
      ],
      no_of_installments_options: [3, 6, 9, 12],
      course_types: [
        { id: 1, type: 'self_based', value: 'Self Paced Course' },
        { id: 2, type: 'online_one_2_one', value: 'Online Individual Course' },
        { id: 3, type: 'online_one_2_many', value: 'Online Group Course' },
        {
          id: 4,
          type: 'offline_one_2_one',
          value: 'In Person Individual Course'
        },
        { id: 5, type: 'offline_one_2_many', value: 'In Person Group Course' }
      ],
      locations: [
        {
          id: 1,
          name: 'At School'
        },
        {
          id: 2,
          name: 'Online'
        },
        {
          id: 3,
          name: 'At Home'
        },
        {
          id: 4,
          name: 'Other'
        }
      ],
      classroom: false,
      equipments: false,
      fileName: '',
      inventoryList: [],
      courseImage: null,
      courseVideo: null
    }
  },
  created () {
    this.customer_id = localStorage.getItem('customer_id')
    this.fetchSubjectList()
    if (this.$route.params.course_id) {
      this.course_id = this.$route.params.course_id
      this.fetchCourseDetails()
    }
    this.fetchInventoryList()
    this.getRepositoryId(3)
  },
  components: {
    vSelect,
    FileUpload
  },
  props: {
    courseId: {
      required: false,
      default: null
    },
    counter: {
      required: false,
      default: 0
    },
    course_builder_wizard_self_based: {
      required: false
    }
  },
  watch: {
    courseId () {
      this.course_id = this.courseId
      this.fetchCourseDetails()
    },
    show () {
      if (!this.show) {
        this.observer.disconnect()
      }
    },
    selectAllSubjects (newVal) {
      if (newVal) {
        this.subjects = this.subjectlist.filter((ele) => ele.id !== 0)
      } else {
        this.subjects = null
      }
    },
    subjects () {
      this.subjects.forEach((element) => {
        this.subjectlist = this.subjectlist.map((subject) => {
          if (subject.id === element.id) {
            subject.selected = true
          }
          return subject
        })
      })
    }
    // allSub () {
    //   console.log('all subjects watch called', this.subjects)
    //   this.subjects = []
    //   this.has_all_subject = this.allSub
    // }
  },
  methods: {
    getIdFile (obj) {
      if (Array.isArray(obj)) {
        this.file_id = obj[0]
      } else {
        this.file_id = obj
        console.log(obj)
      }
    },
    deletedIndex (deleteIndex) {
      this.filesInfo.splice(0)
      this.file_id = null
    },
    async createCourse () {
      console.log(this.subjects)
      try {
        const validAll = await this.$validator.validateAll('Course')
        console.log(this.tutors)

        if (validAll) {
          console.log(
            document.getElementsByClassName(
              'course_builder_wizard_self_based'
            )[0]
          )
          this.room_ids.forEach((element, index) => {
            this.courseStructure.courseClassPrioritySetting.push({
              asset_id: element,
              priority: index + 1
            })
          })
          this.courseStructure = Object.assign({}, this.courseStructure, {
            courseAsset: this.courseAsset
          })
          const payload = {
            ...this.coursePayload,
            has_all_subject: this.has_all_subject,
            tutors: this.tutors,
            coursePaymentSetting: this.coursePaymentSetting,
            courseStructure: this.courseStructure,
            courseImage: this.courseImage,
            courseVideo: this.courseVideo,
            subjects: this.subjects
          }

          const data = await createCourseDetails(
            this.customer_id,
            payload,
            this.course_id
          )

          this.$emit('course', data.data.data.course)
        } else {
          this.showSuccessMessage('Error', 'Please fill the mandatory fields', 'danger')
        }
      } catch (e) {
        console.log(e)
      }
    },
    async updateCourse () {
      try {
        const validAll = await this.$validator.validateAll('Course')

        if (validAll) {
          this.courseStructure.course_type = this.courseStructure.course_type
          this.courseStructure.courseClassPrioritySetting = []
          this.room_ids.forEach((element, index) => {
            this.courseStructure.courseClassPrioritySetting.push({
              asset_id: element,
              priority: index + 1
            })
          })

          this.courseStructure = Object.assign({}, this.courseStructure, {
            courseAsset: this.courseAsset
          })
          const payload = {
            ...this.coursePayload,
            has_all_subject: this.has_all_subject,
            tutors: this.tutors,
            coursePaymentSetting: this.coursePaymentSetting,
            courseStructure: this.courseStructure,
            courseImage: this.courseImage,
            courseVideo: this.courseVideo,
            subjects: this.subjects
          }

          const data = await updateCourseDetails(
            this.customer_id,
            payload,
            this.course_id
          )
          this.$router.push({
            name: 'course edit',
            params: {
              course_id:  this.course_id,
              course_class_type: this.courseStructure.course_type.type
            }
          })
          this.$emit('course', data.data.data.course)

        } else {
          this.showSuccessMessage('Error', 'Please fill the mandatory fields', 'danger')
        }
      } catch (e) {
        console.log(e)
      }
    },
    async fetchInventoryList () {
      try {
        const payload = {}

        payload.limit = 10

        const responseList = await inventoryOrRoomListApi(
          this.customer_id,
          'Inventory',
          this.inventory_meta,
          payload
        )
        this.inventoryList = responseList.data.data.assets_list
        this.inventory_meta = responseList.data.data.meta
      } catch (error) {
        //
      }
    },

    async fetchCourseDetails () {
      try {
        const { data } = await getCourseDetails(
          this.customer_id,
          this.course_id
        )
        this.coursePayload = data.data.course
        this.courseStructure = data.data.course.courseStructure
        this.coursePaymentSetting = data.data.course.coursePaymentSetting
        this.courseImage = data.data.course.courseImage.id
        this.courseVideo = data.data.course.courseVideo.id
        this.preview = data.data.course.courseImage.file_path
        this.preview_video = data.data.course.courseVideo.file_path
        this.video = data.data.course.courseVideo.file_name
        this.tutors = data.data.course.tutors
        this.has_all_subject = data.data.course.has_all_subject
        this.allSub = this.has_all_subject
        this.subjects = data.data.course.subjects
        this.room_ids = this.courseStructure.courseClassPrioritySetting.map(
          (ele) => {
            return ele.asset_id
          }
        )
        this.courseAsset = data.data.course.courseAsset.map((ele) => {
          return ele.id
        })
        this.disableOtherLi = this.has_all_subject


        this.courseStructure.course_type = this.course_types.filter(
          (ele) => ele.id === this.courseStructure.course_type.id
        )
        this.courseStructure.course_type = this.courseStructure.course_type[0]

        if (this.has_all_subject) {
          this.genSub()
        }

      } catch (e) {
        //
      }
    },
    async loadMoreInventory ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          const payload = {}

          payload.limit = 10
          this.inventory_meta.current_page =
            this.inventory_meta.current_page + 1
          const responseList = await inventoryOrRoomListApi(
            this.customer_id,
            'Inventory',
            this.inventory_meta,
            payload
          )
          this.inventoryList.push(...responseList.data.data.assets_list)
          this.inventory_meta = responseList.data.data.meta
        } catch (e) {}
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },

    async onOpenInventory () {
      if (this.inventory_meta.has_next) {
        await this.$nextTick()
        this.observerInventory.observe(this.$refs.loadInventory)
      }
    },
    onCloseInventory () {
      this.observerInventory.disconnect()
    },

    calculateInstallmentAmt () {
      this.coursePaymentSetting.installment_amount = Math.ceil(
        this.coursePaymentSetting.total_price /
          this.coursePaymentSetting.no_of_installments
      )
    },
    outsideDropdown () {
      this.show = false
    },
    async showDropdown () {
      this.show = !this.show
      if (this.subjectMeta.has_next) {
        await this.$nextTick()
        this.observerSubject.observe(this.$refs.load)
      }
    },
    pushTolocalValue (option) {
      this.subjects.push(option)
    },
    removeDataOption (index, id) {
      this.subjects.splice(index, 1)
      this.subjectlist = this.subjectlist.map((subject) => {
        if (subject.id === id) {
          subject.selected = false
        }
        return subject
      })
    },
    searchSubjectList () {
      this.searchOption.replace(/ /g, '')
      this.subjectlist = this.subjectlist.filter((ele) => {
        if (
          ele.subject_name.replace(/ /g, '') ===
          this.searchOption.replace(/ /g, '')
        ) {
          return ele
        }
      })
      if (this.searchOption.replace(/ /g, '') === '') {
        this.fetchSubjectList()
      }
    },
    genSub () {
      this.disableOtherLi = true
      this.allSub = true
      this.has_all_subject = true
    },
    removeGenSub () {
      this.disableOtherLi = false
      this.allSub = false
      this.has_all_subject = false
    },
    async fetchSubjectList () {
      const customerId = this.$store.getters.customerId
      try {
        const { data } = await list_subject(customerId, 1)
        this.subjectlist = data.data.subjectlist
        this.subjectlist = this.subjectlist.map((subject) => {
          subject.selected = false
          return subject
        })

        this.subjectMeta = data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    async loadMore ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          const response = await list_subject(
            this.$store.getters.customerId,
            this.subjectMeta.current_page + 1
          )
          const tempSubjectList = [...response.data.data.subjectlist]
          this.subjectlist.push(...tempSubjectList.map((subject) => {
            if (this.subjects.map((element) => element.id).includes(subject.id)) {
              subject.selected = true
            } else {
              subject.selected = false
            }
            return subject
          }))

          this.subjectMeta = response.data.data.meta
        } catch (e) {
          //
        }
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async previewImage (event) {
      const input = event.target
      if (input.files) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.preview = e.target.result
        }
        this.image = input.files[0]
        reader.readAsDataURL(input.files[0])

        const formData = new FormData()
        formData.append('files[]', input.files[0])

        const data = await UploadImage(formData, this.customer_id)
        const cdn = data.data.data.cdn

        const file_name = data.data.data.files[0].file_name
        const file_path = data.data.data.files[0].file_path

        const raw = JSON.stringify({
          file_repository_id: this.repository_id,
          files: [
            {
              file_name,
              file_path: `${cdn}${file_path}`
            }
          ]
        })

        const file_id_payload = raw

        this.getUploadFiles(file_id_payload, 'image')
      }
    },
    async getUploadFiles (file_id_payload, type) {
      const res = await addFile(file_id_payload)
      if (type === 'image') {
        this.courseImage = res.data.data.files[0].files_id
      } else {
        this.courseVideo = res.data.data.files[0].files_id
      }

      if (res.data.message === 'files.createFile') {
        const file = {
          file: res.data.data.files[0]
        }
        // this.filesInfo.push(file)

        // this.filesId.push(res.data.data.files[0].files_id)

        this.$vs.loading.close()
      }
    },
    async previewVideo (event) {
      const input = event.target
      if (input.files) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.preview_video = e.target.result
        }
        this.video = input.files[0]
        reader.readAsDataURL(input.files[0])

        const formData = new FormData()
        formData.append('files[]', input.files[0])

        const data = await UploadImage(formData, this.customer_id)
        const cdn = data.data.data.cdn

        const file_name = data.data.data.files[0].file_name
        const file_path = data.data.data.files[0].file_path

        const raw = JSON.stringify({
          file_repository_id: this.repository_id,
          files: [
            {
              file_name,
              file_path: `${cdn}${file_path}`
            }
          ]
        })

        const file_id_payload = raw

        this.getUploadFiles(file_id_payload, 'video')
      }
    }
  },
  directives: {
    'click-outside': {
      bind (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          /* eslint-disable no-mixed-operators */
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            /* eslint-enable no-mixed-operators */
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
}
</script>
<style scoped>
.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  /* background-color: #eef1f6;
      border-color: #d1dbe5;    */
}
</style>
